import { Injectable } from '@angular/core';
import {Store} from '@ngxs/store';
import {IIndicatorsPatientConsultation} from '../../models/measurement';
import {firstValueFrom} from 'rxjs';
import {PatientAction, PatientState} from '../../models/patient';

@Injectable({
  providedIn: 'root'
})
export class IngredientService {

  constructor(
    private store: Store
  ) { }

  async getAllergiesPatient(): Promise<string[]> {
    const patientServiceInfo: IIndicatorsPatientConsultation = await firstValueFrom(this.store.selectOnce(PatientState.getPatientSelectedInformation));
    await firstValueFrom(this.store.dispatch(new PatientAction.GetAllergicIngredients(patientServiceInfo.servicePatient.patientId, patientServiceInfo.servicePatient.serviceId)));
    return await firstValueFrom(this.store.selectOnce(PatientState.getPatientAllergicIngredients));
  }

  async getDislikesIngredientsPatient(): Promise<string[]> {
    const patientServiceInfo: IIndicatorsPatientConsultation = await firstValueFrom(this.store.selectOnce(PatientState.getPatientSelectedInformation));
    await firstValueFrom(this.store.dispatch(new PatientAction.GetDislikesIngredients(patientServiceInfo.servicePatient.patientId, patientServiceInfo.servicePatient.serviceId)));
    return await firstValueFrom(this.store.selectOnce(PatientState.getPatientDislikesIngredients));
  }
}
